import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { Amplify, Auth } from 'aws-amplify';
import { environment } from '@src/environments/environment'; 

Amplify.configure({
  Auth: {

      // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
      //identityPoolId: 'XX-XXXX-X:XXXXXXXX-XXXX-1234-abcd-1234567890ab',

      // REQUIRED - Amazon Cognito Region
      region: 'eu-central-1',

      // OPTIONAL - Amazon Cognito Federated Identity Pool Region 
      // Required only if it's different from Amazon Cognito Region
      //identityPoolRegion: 'XX-XXXX-X',

      // OPTIONAL - Amazon Cognito User Pool ID
      userPoolId: environment.cognito_user_pool_id, //'eu-central-1_D50hmg5qW',

      // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
      userPoolWebClientId: environment.cognito_client_id,//'ssqs1ot6bcv77tpdj6kqpng5m',

      // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
      //mandatorySignIn: false,

      // OPTIONAL - Configuration for cookie storage
      // Note: if the secure flag is set to true, then the cookie transmission requires a secure protocol
    //   cookieStorage: {
    //   // REQUIRED - Cookie domain (only required if cookieStorage is provided)
    //       domain: environment.cookie_domain,
    //   // OPTIONAL - Cookie path
    //       path: '/',
    //   // OPTIONAL - Cookie expiration in days
    //       expires: 365,
    //   // OPTIONAL - See: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie/SameSite
    //       sameSite: "strict",
    //   // OPTIONAL - Cookie secure flag
    //   // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
    //       //secure: true
    //   },

      // OPTIONAL - customized storage object
      //storage: MyStorage,

      // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
      //authenticationFlowType: 'USER_PASSWORD_AUTH',

      // OPTIONAL - Manually set key value pairs that can be passed to Cognito Lambda Triggers
      //clientMetadata: { myCustomKey: 'myCustomValue' },

       // OPTIONAL - Hosted UI configuration
    //   oauth: {
    //       domain: 'https://worktrest-test.auth.eu-central-1.amazoncognito.com',
    //       scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
    //       redirectSignIn: 'http://localhost:4200/',
    //       redirectSignOut: 'http://localhost:4200/',
    //       responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
    //   }
  }
});


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
